<template>
  <div class="rental slide">
    <VerticalAnimation :animation="animation" :background="background" />
    <div class="vertical-layout animated fadeIn delay-2s">
      <p class="store">STORE 0111</p>
      <h1>Rental Vehicle</h1>
      <p>Hammer is seen getting into the passenger side of a white sedan. API runs the vehicle tag and gets a hit on a rental vehicle from National Car Rental.</p>
    </div>
    <router-link to="/john-deerling">
      <NextButton />
    </router-link>
  </div>
</template>

<script>
import VerticalAnimation from '@/components/VerticalAnimation.vue'
import NextButton from '@/components/NextButton.vue'
import Rental from '@/assets/rental.js'
import VerticalImage from '@/assets/orangeV.png'

export default {
  name: 'rental',
  components: {
    VerticalAnimation,
    NextButton
  },
  data() {
    return {
      animation: Rental,
      background: VerticalImage
    }
  },
  mounted() {
    window.setTimeout(() => {
          window.scrollTo(0,1)
        }, 1000)
  }
}
</script>

<style lang="scss" scoped>
  h1 {
    margin-bottom: 0;
  }

  .animation {
    top: -20px;
  }
  .vertical-layout {
    top: 27%;
  }
</style>
